import React from 'react';
import { Route, Link, Switch, Redirect } from 'react-router-dom';
import isLoggedIn from '../../helpers/is_logged_in';

import Header from './header/header.component';
import MainContent from './main-content/main-content.component';


const WrapperPage = () => {
    if (!isLoggedIn()) {
        return <Redirect to='/signin' />
    }

    return (
        <div>
            <Header></Header>
            <MainContent></MainContent>
        </div>
    )
}

export default WrapperPage
